import axios from 'axios';
import { ReturnCodes } from '../utils/constants';

class HistoryService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL;
        this.historyEndpoint = '/api/v2/history/videos/'; 
        this.restoreEndpoint = '/api/v2/history/restore' 
        this.clearEndpoint = '/api/v2/history/clear/';
    }
    
    async getVideoHistory(videoId, languageName) {
        try {
            const authUser = JSON.parse(localStorage.getItem('authUser'));
            const authToken = JSON.parse(localStorage.getItem('authToken'));
            
            const endpoint = this.apiUrl + this.historyEndpoint + videoId;
            console.log('Fetching history from URL:', endpoint);
            
            if(languageName === undefined || languageName === null) {
                languageName = 'English';
            }
            
            const response = await axios.get(endpoint, {
                params: { languageName: languageName },
                headers: { 
                    email: authUser?.email || '',
                    auth: authToken || '',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Credentials': true,
                }
            });
            
            if (response.status === ReturnCodes.OK) {
                console.log('History fetched successfully:', response.data);
                return response.data;
            }
            
            return null;
        } catch (error) {
            console.error('Error fetching history:', error);
            return null;
        }
    }

    // Add this method to your HistoryService
   async restoreVersion (videoId, languageName, versionNumber){
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const authToken = JSON.parse(localStorage.getItem('authToken'));
        
        const endpoint = this.apiUrl + this.restoreEndpoint;
        const userData = JSON.parse(localStorage.getItem('authUser'));
        if (!userData) {
        throw new Error('User not authenticated');
        }
        
        const formData = new FormData();
        formData.append('videoId', videoId);
        formData.append('languageName', languageName);
        formData.append('versionNumber', versionNumber);
        formData.append('userEmail', userData.email);
        
        const response = await axios.post(
        `${endpoint}`, 
        formData,
        {
            headers: {
            'Authorization': `Bearer ${userData.access}`
            }
        }
        );
        
        return response.data;
   }
    

   // Clear version history for a video
   clearVersionHistory(videoId) {
    const apiBaseUrl = process.env.REACT_APP_API_URL;
    
    const endpoint = this.apiUrl + this.clearEndpoint + videoId;

    return axios.delete(endpoint);
    }
}

const historyService = new HistoryService();
export default historyService;